import React, { useCallback, useState } from "react";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";
import moment from "moment";

const SearchBar = (props) => {
  // SerachBar 기본 필드

  const {
    store: { userInfo },
  } = useAppContext();

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;
    //console.log("name === " + name + " || value === " + value);

    props.setSearchParameters({ ...props.searchParameters, [name]: value });
  });

  return (
    <>
      <div className="searchdata">
        <ul>
          <li className="date">
            <div className="divide40">
              <font color="grey">⦁</font> 입고일자
            </div>
            <div className="flex50">
              <input
                type="date"
                name="schSinspDt"
                id="schSinspDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.searchParameters.schSinspDt}
              />
              &nbsp;~&nbsp;
              <input
                type="date"
                name="schEinspDt"
                id="schEinspDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.searchParameters.schEinspDt}
              />
            </div>
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 사업장구분
            </div>
            <SelectBox
              mastCd="PLANT_CD"
              id="schPlantCd"
              name="schPlantCd"
              data_value="attr3"
              topSelected="전체"
              attr5="Y"
              onChange={handleChangeField}
              value={props.searchParameters.schPlantCd}
              className="datainput"
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 검수등급
            </div>
            <SelectBox
              mastCd="ITEM_CD"
              name="schDcsnItemCd"
              id="schDcsnItemCd"
              topSelected="전체"
              onChange={handleChangeField}
              className="datainput"
              value={props.searchParameters.schDcsnItemCd}
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 공급업체
            </div>
            <input
              type="text"
              name="schvndrNm"
              id="schvndrNm"
              onChange={handleChangeField}
              className="datainput"
              value={props.searchParameters.schvndrNm}
              style={{ width: "120px" }}
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 차량번호
            </div>
            <input
              type="text"
              name="schVhclNo"
              id="schVhclNo"
              onChange={handleChangeField}
              className="datainput"
              value={props.searchParameters.schVhclNo}
              style={{ width: "120px" }}
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 배차구분
            </div>
            <select
              name="schOdrType"
              id="schOdrType"
              onChange={handleChangeField}
              className="datainput"
              value={props.searchParameters.schOdrType}
            >
              <option value="">전체</option>
              <option value="10">국내고철</option>
              <option value="30">국내바지선</option>
            </select>
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
